const CURRENCIES = {
  eu: '€',
  usd: '$'
};

export default function (currency) {
  if (currency in CURRENCIES) {
    return CURRENCIES[currency];
  }

  return '₺';
}



// WEBPACK FOOTER //
// ./src/constants/currencies.js